/**
 * The tiled upload queue of the `<Canvas>` a consumer draws in. Null outside
 * one, where a texture has no renderer to upload to and passes straight through.
 */
import { createContext } from 'react';
export const TiledUploadContext = createContext(null);
//# sourceMappingURL=TiledUploadContext.js.map